import React, { useEffect, useRef } from 'react';

const RejectionModal = ({ open, onClose }) => {
  const modalRef = useRef();

  useEffect(() => {
    const handler = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
      }
    };
    if (open) document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="celebration-popup">
      <div className="celebration-content" ref={modalRef}>
        <button className="close-btn" onClick={onClose}>×</button>
        <h2>Alright!</h2>
        <p>Will try to impress you next time</p>
      </div>
    </div>
  );
};

export default RejectionModal;
